<template>
  <div></div>
</template>

<style lang="scss" scoped></style>

<script>
export default {
  beforeMount() {
    this.$router.push({ name: "login" });
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style></style>
